import * as React from "react";
import { cn } from "@/lib/utils";

function Suggestions({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="suggestions"
      className={cn("flex flex-wrap gap-2", className)}
      {...props}
    />
  );
}

function Suggestion({ className, ...props }: React.ComponentProps<"button">) {
  return (
    <button
      type="button"
      data-slot="suggestion"
      className={cn(
        "rounded-md border border-[#D4D4D4] bg-white px-3 py-2 text-left text-xs font-medium text-[#171717] transition-colors hover:border-[#A3A3A3] hover:bg-[#F5F5F5] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#FF5E00]/30 disabled:cursor-not-allowed disabled:opacity-60",
        className,
      )}
      {...props}
    />
  );
}

export { Suggestion, Suggestions };
